import { Card, CardHeader, CardTitle, CardContent, EmptyState } from '@/components/ui'
import { Palette } from 'lucide-react'

export function BrandingSettingsPage() {
  return (
    <div className="space-y-6 max-w-2xl">
      <Card>
        <CardHeader>
          <CardTitle>Branding</CardTitle>
        </CardHeader>
        <CardContent>
          <EmptyState
            icon={Palette}
            title="Coming Soon"
            description="Customize your organization's branding including colors and logos for login screens."
          />
        </CardContent>
      </Card>
    </div>
  )
}
